import { PointerActivationConstraints, PointerSensor } from "@skilitics/drag-drop";

// Don't activate drag from pointers landing in editable text — text selection
// would otherwise immediately turn into a reorder drag.
const isEditableTextTarget = (target: EventTarget | null): boolean => {
  if (!(target instanceof Element)) return false;
  if (target.closest("input, textarea, [contenteditable=''], [contenteditable='true']")) return true;
  return false;
};

const isInteractiveContentTarget = (target: EventTarget | null): boolean => {
  if (!(target instanceof Element)) return false;
  return !!target.closest("model-viewer");
};

export const dndSensors = [
  PointerSensor.configure({
    activationConstraints: (event) => {
      if (event.pointerType === "touch") {
        return [new PointerActivationConstraints.Delay({ value: 250, tolerance: 5 })];
      }
      return [new PointerActivationConstraints.Distance({ value: 3 })];
    },
    preventActivation: (event) => isEditableTextTarget(event.target) || isInteractiveContentTarget(event.target),
  }),
];
